import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  dropdownBox: {
    background: theme.palette.common.white,
    boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.1)",
    position: "absolute",
    zIndex: 1,
    top: "45px",
    width: "100%",
    borderRadius: 4,
    maxHeight: "450px",
    overflow: "scroll",
  },
}));
